// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlusCircleFilledSvg from "@ant-design/icons-svg/es/asn/PlusCircleFilled";
import AntdIcon from '../components/AntdIcon';

var PlusCircleFilled = function PlusCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlusCircleFilledSvg
  }));
};

PlusCircleFilled.displayName = 'PlusCircleFilled';
export default React.forwardRef(PlusCircleFilled);